import React from 'react';
import Table from './table';
import TableInEdit from './table-in-edit';

const SpecialOfferTable = props => {
  const { inEdit, ...extraProps } = props;
  if (inEdit) return <TableInEdit {...extraProps} />;
  return <Table {...extraProps} />;
};

export default SpecialOfferTable;



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/special-offer-tables/special-offer-table.jsx